import httpApi, {
  serializeJSON,
  setAuthorizationToken,
  setInternalAuthorization,
  devBackendBaseUrl,
  testBackendBaseUrl,
  prodBackendBaseUrl,
} from './utils/httpClient';

import { setLocalEnv, setDevEnv, setTestEnv, setProdEnv } from './slices/localDataSlice';

import { useCanUserLoginWithSalesforce, useUserLoginProviderAccountId } from './hooks/userLoginProvider'

import {
  getAccountCustomLinkButtonData,
  updateAccountCustomLinkButtonData,
  resetCustomLinkButtonState
} from './slices/accountCustomLinkButtonSlice';

import {
  getAccountCustomSchedulingButtonData,
  updateAccountCustomSchedulingButtonData,
  resetCustomSchedulingButtonState,
} from './slices/accountSchedulingButtonSlice';

import {
  getClassSessionConfig,
  accountSliceClean,
  enableClassSession,
  updateReminders,
  updateConfig,
} from './slices/accountClassSessionConfigSlice';

import {
  getExternalAppsConfigThunk,
  enableExternalAppsThunk,
  getExternalAppsListThunk, addExternalAppThunk,
  getAccountAppsAvailabilityThunk, updateAccountAppAvailabilityThunk, updateAccountAppsAvailabilityThunk,
  getAccountAppsThunk, resetAccountAppThunk, updateAccountAppsConfigThunk,
  getPatientAppsThunk, resetPatientAppThunk, updatePatientAppsConfigThunk,
  getAppInfoThunk, deleteExternalAppThunk
} from './slices/accountExternalAppsSlice';


import { getAccountIntegrationConfig } from './slices/accountIntegrationConfigSlice';

import { logFamilyInfo, familyMemberMe } from './slices/familySlice';

import {
  updateDeviceHardwareInfo,
  updateDeviceControllerInfo,
  updateDeviceStateInfo,
  updateDevicePosition,

  getDeviceIdBySerialNumber
} from './slices/deviceSlice';

import { trackAppStarted, trackAppStopped } from './slices/externalAppSlice';

import {
  getUserConfig,
  getUserConfigPromise,
  enableClassSessionAccessToUser,
  enableSalesforceImportToUser,
  enableReportsToUser,
  clearUserConfig,
  updateUserConfigPromise
} from './slices/userConfig';

import { getLoggedInUserConfig } from './slices/loggedInUserConfig';

import {
  createClassSession,
  updateClassSession,
  getClassSessions,
  startClassSession,
  cancelClassSession,
  sessionSliceClean,
} from './slices/classSessionSlice';

import { getUsersWithClassroomAccess } from './slices/classSessionUser';

import {
  getClassSessionPatient,
  getClassSessionPatientDevice,
  classsSessionPatientSliceClean,
} from './slices/classSessionPatient';

import {
  reset as resetUser,
  setUser,
  setError as setUserError,
  setPending as setUserPending,
  userMe,
} from './slices/userSlice';

import { getDevicesAddedByDate, csReportsSliceClean } from './slices/csReports';
import { getAllCsUsers, updateCsUser, deleteCsUser, csUsersSliceClean } from './slices/csUsers';
import {
  validateCallUrlPromise,
  startCall,
  onCallEvent,
  onCallPeerVideoSize,
  endCall,
  setLoudestPeer,
  reportCallStartedPromise, reportMultiCallStartedPromise,
  requestCallPromise,
  requestCallThunk
} from './slices/callSlice';

import { getSystemDevices, getDeviceInfo, csDevicesSliceClean } from './slices/csDevices';
import { fetchDeviceInfo, fetchDeviceInfoSerialNumber } from './slices/deviceSlice';

import { store, rootReducer } from './store';
import { getOrders, getOrderDetails, consumerSliceClean } from './slices/consumer';
import { getBulletinsThunk, createBulletinThunk, updateBulletinThunk, deleteBulletinThunk, patientBulletinSliceClean } from './slices/patientBulletin';
import {
  getDeviceForBillingReportPromise, getAccountCallsThunk, reportsSliceClean,
  getExternalAppsUsageReportDataThunk, reportsAppUsageClean
} from './slices/reports';
import { getAccountDevicesPromise } from './slices/account'
// mdmPolicy
import {
  fetchMdmPolicyData, fetchMdmPolicyDetailsData, saveMdmPolicyData, createMdmPolicyData, fetchEnterprisesValues, createEnterprise, updateEnterprise, resetFetchMdmPolicyDetailsDataState, resetSuccessFormState, deleteMdmPolicyData,
  resetDeleteMdmPolicyState
} from './slices/mdmPolicy/mdmPolicyDataSlice'
import {
  addPolicyJSONProperties, removePolicyJSONProperty, removePropertyOnPluggedModes, addPropertyOnPluggedModes, setPolicyInformation, setPolicyJSON, resetMDMPolicyState,
  setPolicyFormStatus,
  updatePolicyFormStatus,
  addPolicyInformationProperties,
  removePolicyInformationProperty,
  setNetworkConfigurationsInPolicyJSON,
  removeNetworkByGUID,
  setPolicyScreen,
  setApps,
  setAlreadySavedJSON,
  setAlreadyPolicyInformation,
  resetPolicyJsonState
} from './slices/mdmPolicy/mdmPolicyStateSlice'
import {
  fetchMdmAccounts, resetFetchAccounts, fetchMdmAccountsDevicesCount, resetFetchMdmAccountsDevicesCountState, resetCreateAccount,
  createMdmAccount, patchMdmAccount, fetchMdmAccountByID,
  resetPatchAccount, resetFetchAccountInformationByID,
  fetchMdmAccountPolicyTemplates,
  resetFetchAccountPolicyTemplates,
  fetchMdmAccountDevices,
  resetFetchMdmAccountDevices,
  assignPolicyTemplatesToMdmAccount,
  resetAssignPolicyTemplatesToMdmAccount,
  resetHandleCreateOrRenewEnrollmentTokenState,
  handleRenewEnrollmentToken,
} from './slices/mdmAccounts/mdmAccountsDataSlice';
import {
  deletePolicyTemplatesByID, resetDeletePolicyTemplatesByID,
  resetPatchPriorityTemplatesByIDState,
  patchPriorityTemplatesByID,
} from './slices/mdmPolicyTemplates/mdmPolicyTemplatesDataSlice';
import {
  fetchMdmDevicesList,
  fetchMdmDevicePolicies,
  resetFetchDeviceList,
  resetFetchDeviceDetails,
  resetFetchDevicePoliciesState,
  fetchMdmDeviceDetails,
  assignPolicyTemplatesToMdmDevice,
  unassignPolicyTemplateFromMdmDevice,
  resetAssignPolicyTemplatesToMdmDeviceState,
  resetUnassignPolicyTemplateFromMdmDeviceState,
  updateMdmDeviceData,
  deleteMdmDevice,
  resetDeleteMdmDeviceState,
  refreshMdmDevicePolicy,
} from './slices/mdmDevice/mdmDeviceDataSlice'

export {
  setLocalEnv,
  setDevEnv,
  setTestEnv,
  setProdEnv,
  // user
  resetUser,
  setUser,
  setUserError,
  setUserPending,
  userMe,
  // user config
  getUserConfig,
  getUserConfigPromise,
  enableClassSessionAccessToUser,
  enableSalesforceImportToUser,
  enableReportsToUser,
  clearUserConfig,
  updateUserConfigPromise,
  // loggedInUserConfig
  getLoggedInUserConfig,
  // class session user
  getUsersWithClassroomAccess,
  // account integration
  getAccountIntegrationConfig,
  // account
  getAccountDevicesPromise,
  //Class Session
  getClassSessionConfig,
  accountSliceClean,
  enableClassSession,
  updateReminders,
  updateConfig,
  createClassSession,
  updateClassSession,
  getClassSessions,
  startClassSession,
  cancelClassSession,
  sessionSliceClean,
  getClassSessionPatient,
  getClassSessionPatientDevice,
  classsSessionPatientSliceClean,
  rootReducer,
  httpApi,
  setAuthorizationToken,
  setInternalAuthorization,
  serializeJSON,
  devBackendBaseUrl,
  testBackendBaseUrl,
  prodBackendBaseUrl,
  logFamilyInfo,
  familyMemberMe,
  csReportsSliceClean,
  getDevicesAddedByDate,

  fetchDeviceInfo, fetchDeviceInfoSerialNumber,
  getSystemDevices, getDeviceInfo, csDevicesSliceClean,

  getAllCsUsers, updateCsUser, deleteCsUser, csUsersSliceClean,
  getOrders, getOrderDetails, consumerSliceClean,
  getBulletinsThunk, createBulletinThunk, updateBulletinThunk, deleteBulletinThunk, patientBulletinSliceClean,
  getAccountCallsThunk, reportsSliceClean, getDeviceForBillingReportPromise,
  getExternalAppsUsageReportDataThunk, reportsAppUsageClean,
  validateCallUrlPromise,
  startCall,
  onCallEvent, onCallPeerVideoSize,
  endCall,
  reportCallStartedPromise, reportMultiCallStartedPromise,
  requestCallPromise,

  requestCallThunk,

  setLoudestPeer,

  updateDeviceHardwareInfo,
  updateDeviceControllerInfo,
  updateDeviceStateInfo,
  updateDevicePosition,
  getDeviceIdBySerialNumber,

  trackAppStarted, trackAppStopped,
  // selectors
  useCanUserLoginWithSalesforce,
  useUserLoginProviderAccountId,

  getExternalAppsConfigThunk, enableExternalAppsThunk,
  getExternalAppsListThunk, addExternalAppThunk,
  getAccountAppsAvailabilityThunk, updateAccountAppAvailabilityThunk, updateAccountAppsAvailabilityThunk,
  getAccountAppsThunk, resetAccountAppThunk, updateAccountAppsConfigThunk,
  getPatientAppsThunk, resetPatientAppThunk, updatePatientAppsConfigThunk,
  getAppInfoThunk, deleteExternalAppThunk,

  // mdmPolicy
  fetchMdmPolicyData,
  fetchMdmPolicyDetailsData,
  saveMdmPolicyData,
  deleteMdmPolicyData,
  resetDeleteMdmPolicyState,
  createMdmPolicyData,
  fetchEnterprisesValues,
  createEnterprise,
  updateEnterprise,
  resetFetchMdmPolicyDetailsDataState,
  resetSuccessFormState,
  addPolicyJSONProperties, removePolicyJSONProperty, removePropertyOnPluggedModes, addPropertyOnPluggedModes, setPolicyInformation, setPolicyJSON, resetMDMPolicyState,
  setPolicyFormStatus,
  updatePolicyFormStatus,
  addPolicyInformationProperties,
  removePolicyInformationProperty,
  setNetworkConfigurationsInPolicyJSON,
  removeNetworkByGUID,
  setPolicyScreen,
  setApps,
  setAlreadySavedJSON,
  setAlreadyPolicyInformation,
  resetPolicyJsonState,
  fetchMdmAccounts,
  fetchMdmAccountsDevicesCount,
  createMdmAccount,
  patchMdmAccount,
  fetchMdmAccountByID,
  fetchMdmAccountPolicyTemplates,
  fetchMdmAccountDevices,
  assignPolicyTemplatesToMdmAccount,
  resetFetchAccounts,
  resetFetchMdmAccountsDevicesCountState,
  resetCreateAccount,
  resetPatchAccount,
  resetFetchAccountInformationByID,
  resetFetchAccountPolicyTemplates,
  resetFetchMdmAccountDevices,
  resetAssignPolicyTemplatesToMdmAccount,
  // TMdmPolicyTemplates
  deletePolicyTemplatesByID, resetDeletePolicyTemplatesByID,
  resetHandleCreateOrRenewEnrollmentTokenState,
  handleRenewEnrollmentToken,
  resetPatchPriorityTemplatesByIDState,
  patchPriorityTemplatesByID,

  // MdmDevice - DATA
  fetchMdmDevicesList,
  fetchMdmDeviceDetails,
  fetchMdmDevicePolicies,
  resetFetchDeviceDetails,
  resetFetchDevicePoliciesState,
  resetFetchDeviceList,
  assignPolicyTemplatesToMdmDevice,
  unassignPolicyTemplateFromMdmDevice,
  // MdmDevice - STATE
  resetAssignPolicyTemplatesToMdmDeviceState,
  resetUnassignPolicyTemplateFromMdmDeviceState,
  updateMdmDeviceData,
  deleteMdmDevice, resetDeleteMdmDeviceState,
  refreshMdmDevicePolicy,
  //...
  // Custom link button slice
  getAccountCustomLinkButtonData,
  updateAccountCustomLinkButtonData,
  resetCustomLinkButtonState,
  // Custom Scheduling button slice
  getAccountCustomSchedulingButtonData,
  updateAccountCustomSchedulingButtonData,
  resetCustomSchedulingButtonState,
};

export type AppDispatch = typeof store.dispatch;
export default store;
